import { red } from "@ant-design/colors";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import { GrCreditCard } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { useProviderQueries } from "@lib/apiQueries";
import { ROUTES } from "@lib/constants";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";

type Props = {
  cardProps?: AppCardProps;
};

export default function PaymentProvidersMiniCard(props: Props) {
  const { cardProps } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();

  const { providersQuery } = useProviderQueries({
    messages,
    queryKey: ["dashboard-minicard-providers"],
    params: {},
  });
  const { data, isLoading } = providersQuery;
  const apiData = data?.data?.data;

  const total = apiData?.length;
  const newTotal =
    apiData?.filter((d) => {
      const createdAt = dayjs(d.createdAt);
      const startOfMonth = dayjs().startOf("month");
      const endOfMonth = dayjs().endOf("month");

      return createdAt.isBetween(startOfMonth, endOfMonth, null, "[]");
    }) || [];

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.PAYMENT_PROVIDER.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <GrCreditCard />,
        color: red[5],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.provider"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: newTotal.length,
            duration: messages["common.thisMonth"] as string,
          },
        },
      }}
    />
  );
}
